export default __webpack_public_path__ + "static/media/Melbourne-2022.80d0a2ab.jpg";